module.exports = __webpack_public_path__ + "img/4.3dbb5cc9.jpg";